<template>
  <div>
    <van-nav-bar
      title="门店库存管理"
      :left-text="'您好，' + userInfo.emp_name"
    />
    <van-col :span="24">
      <base-input v-model="queryCondition.goods_name" label="产品名称" />
    </van-col>
    <van-col :span="18" v-if="userInfo.source_ids">
      <base-select v-model="queryCondition.source_id" label="库房" :options="queryCondition.sourceList" />
    </van-col>
    <van-col :span="18" @click="showSearchListOfClient = true" v-else>
      <base-input v-model="queryCondition.source_name" label="库房" required readonly />
    </van-col>
    <van-popup v-model="showSearchListOfClient" :style="{ height: '60%' }" position="bottom">
      <base-search-client-list @change="onConfirmOfSelectClient" />
    </van-popup>
    <van-col :span="6" style="text-align: right; padding-right: 10px; padding-top: 5px;">
      <base-button @click="query">查询</base-button>
    </van-col>
    <van-col :span="24">
      <van-pull-refresh v-model="refreshing" @refresh="query">
        <van-list
          v-model="loading"
          :finished="finished"
          finished-text="没有更多了"
          @load="query"
        >
          <van-panel v-for="row in data" :key="row.id" :title="row.goods_name"
                     :desc="row.goods_type_name + ' ' + row.goods_specs"
                     :status="row.default_purchase_count + ' ' + row.default_purchase_name"
          >
          </van-panel>
        </van-list>
      </van-pull-refresh>
    </van-col>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { getGoodsStorageList } from '@/api/stock/goods-storage'
import { getClientList } from '@/api/settings/client'
export default {
  name: 'StockGoodsStorage',
  data() {
    return {
      data: [],
      loading: false,
      finished: false,
      refreshing: false,
      showSearchListOfClient: false,

      queryCondition: {
        total: this.CONST.PAGINATION.TOTAL,
        page: this.CONST.PAGINATION.PAGE,
        rows: this.CONST.PAGINATION.MAX_ROWS,
        sort: 'id',
        order: 'desc',
        goods_name: '',
        storage_id: null,
        source_id: null,
        source_name: '',
        sourceList: []
      }
    }
  },
  computed: {
    ...mapGetters(['userInfo'])
  },
  mounted() {
    this.queryCondition.sourceList = []
    const sourceIdList = this.userInfo.source_ids ?
      this.userInfo.source_ids.split(',') : []
    const sourceNameList = this.userInfo.source_names ?
      this.userInfo.source_names.split(',') : []
    for (let i = 0, j = sourceIdList.length; i < j; i++) {
      this.queryCondition.sourceList.push({
        id: parseInt(sourceIdList[i]),
        name: sourceNameList[i]
      })
    }
    if (this.queryCondition.sourceList && this.queryCondition.sourceList.length > 0) {
      this.queryCondition.source_id = parseInt(this.queryCondition.sourceList[0].id)
      this.queryCondition.source_name = this.queryCondition.sourceList[0].name
    }
    this.query()
  },
  methods: {
    async query() {
      if (this.queryCondition.source_id) {
        this.data = []
        this.loading = true
        this.finished = false
        this.refreshing = false

        const clientResp = await getClientList({
          id: this.queryCondition.source_id
        })
        const clientRows = clientResp.rows || []
        if (clientRows.length > 0) {
          this.queryCondition.storage_id = clientRows[0].storage_id
          if (this.queryCondition.storage_id) {
            getGoodsStorageList(this.queryCondition).then(resp => {
              this.data = resp.rows || []
              this.data.forEach(row => {
                if (row.default_purchase === 0) {
                  row.default_purchase_name = row.base_name
                  row.default_purchase_count = row.count
                } else if (row.default_purchase === 1) {
                  row.default_purchase_name = row.auxiliary1_name
                  row.default_purchase_count = row.count1
                } else if (row.default_purchase === 2) {
                  row.default_purchase_name = row.auxiliary2_name
                  row.default_purchase_count = row.count2
                } else if (row.default_purchase === 3) {
                  row.default_purchase_name = row.auxiliary3_name
                  row.default_purchase_count = row.count3
                }
              })
              this.loading = false
              this.finished = true
            }).catch(error => {
              this.loading = false
              this.finished = true
            })
          } else {
            this.loading = false
            this.finished = true
            this.error('此来源未绑定库房')
          }
        }
      } else {
        this.loading = false
        this.finished = true
      }
    },
    onConfirmOfSelectClient(client) {
      this.queryCondition.source_name = client.name
      this.queryCondition.source_id = client.id
      this.showSearchListOfClient = false
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/stock/goods-storage.vue